import WorkflowRegistryError from './workflow-registry-error'

const isCondition = condition => (
    condition
    && typeof condition.id === 'string'
    && condition.id.length > 0
    && typeof condition.evaluate === 'function'
)

const createConditionRegistry = () => {
    const conditions = new Map()

    const get = id => conditions.get(id) || null

    const resolve = id => {
        const condition = get(id)

        if (!condition) {
            throw new WorkflowRegistryError(
                'UNKNOWN_CONDITION',
                `Condition "${id}" is not registered`,
                { id },
            )
        }

        return condition
    }

    return Object.freeze({
        register(condition) {
            if (!isCondition(condition)) {
                throw new WorkflowRegistryError(
                    'INVALID_CONDITION_REGISTRATION',
                    'A condition registration requires an id and evaluate(context)',
                )
            }

            if (conditions.has(condition.id)) {
                throw new WorkflowRegistryError(
                    'DUPLICATE_CONDITION',
                    `Condition "${condition.id}" is already registered`,
                    { id: condition.id },
                )
            }

            const registration = Object.freeze({ ...condition })

            conditions.set(condition.id, registration)

            return registration
        },
        get,
        resolve,
        has(id) {
            return conditions.has(id)
        },
        evaluate(id, context) {
            const result = resolve(id).evaluate(context)

            if (typeof result !== 'boolean') {
                throw new WorkflowRegistryError(
                    'INVALID_CONDITION_RESULT',
                    `Condition "${id}" must return a boolean`,
                    { id, value: result },
                )
            }

            return result
        },
    })
}

export { createConditionRegistry }
export default createConditionRegistry
